import { useState } from "react";
import { useSelector } from "react-redux";
import dayjs, { Dayjs } from "dayjs";
import classes from "./TimeComponent.module.css";
import { TextEnum } from "../../SolarGikLib/TextStyles";
import { RootState } from "../app/Store";
import { useInterval } from "../../common/Hooks/useInterval";

interface TimeComponentProps {
  value?: Dayjs;
  timeZone?: string;
}

export function getSiteTimeNow(siteTimezone: string): Dayjs {
  return siteTimezone ? dayjs().tz(siteTimezone) : dayjs();
}

function formatDateTime(timezone: string, value?: Dayjs) {
  const siteTimeNow = value ? (timezone ? value.tz(timezone) : value) : getSiteTimeNow(timezone);
  return {
    date: siteTimeNow.format("ddd DD MMM"),
    time: siteTimeNow.format("HH:mm"),
  };
}

const TimeComponent = ({ value, timeZone }: TimeComponentProps) => {
  const selectedTimezone = useSelector((state: RootState) => state.site.ianaTimeZoneName);
  const siteTimezone = timeZone ?? selectedTimezone;
  const [formattedValue, setFormattedValue] = useState(() => formatDateTime(siteTimezone, value));
  useInterval(() => setFormattedValue(formatDateTime(siteTimezone)), value ? null : 1000);
  const displayValue = value ? formatDateTime(siteTimezone, value) : formattedValue;
  return (
    <div className={`${classes["clock-group"]} ${TextEnum.h4}`}>
      <div>{displayValue.date}</div>
      <div className={classes["time"]}>{displayValue.time}</div>
    </div>
  );
};
export default TimeComponent;
